import { render, staticRenderFns } from "./modbus.vue?vue&type=template&id=8e09ece4&scoped=true&"
import script from "./modbus.vue?vue&type=script&lang=js&"
export * from "./modbus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e09ece4",
  null
  
)

export default component.exports